<template>
  <div
    class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0"
    v-if="profile"
  >
    <div class="ml-3 relative">
      <div
        class="flex items-center rounded-3xl border-2 p-1 md:pl-4 md:pr-4 pl-2 pr-2 text-primary cursor-pointer"
        v-on:click="toggleShowProfileMenu"
        id="show_user_menu"
      >
        <img class="h-8 w-8 rounded-full" :src="profile.profilePhoto" />
        <p
          class="md:ml-2 md:mr-2 mr-1 ml-1 md:text-sm text-xs leading-none"
          id="user_name"
        >
          {{ profile.name }}
        </p>
        <svg
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          class="md:h-4 md:w-4 h-3 w-3 transform transition-transform duration-200 ease-in-out"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>

      <div
        v-if="showProfileMenu"
        class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="user-menu-button"
        tabindex="-1"
        id="user_menu"
      >
        <!-- Active: "bg-gray-100", Not Active: "" -->
        <div class="px-4 py-2">
          {{ profile.name }}
          <p class="text-sm text-gray-400" id="user_email">
            {{ profile.email }}
          </p>
        </div>

        <span
          class="px-4 py text cursor-pointer hidden"
          role="menuitem"
          tabindex="-1"
          id="user-menu-item-2"
          v-if="$i18n.locale == I18nLocaleEnum.AR"
          v-on:click="changeLanguage(I18nLocaleEnum.EN)"
          >English 🇺🇸</span
        >

        <span
          class="hidden px-4 py text cursor-pointer"
          role="menuitem"
          tabindex="-1"
          id="user-menu-item-2"
          v-if="$i18n.locale == I18nLocaleEnum.EN"
          v-on:click="changeLanguage(I18nLocaleEnum.AR)"
          >العربية 🇸🇦</span
        >

        <span
          class="block px-4 py text text-red-500 cursor-pointer hover:text-red-700"
          role="menuitem"
          tabindex="-1"
          id="user-logout"
          @click="logout"
          >Log out</span
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ProfileIcon from "./ProfileIcon.vue";
import { Routes } from "./../../../../enums/routes.enum";
import { StorageKeys } from "./../../../../enums/storageKeys.enum";
import authService from "@/services/auth.service";
import Vue from "vue";
import { I18nLocaleEnum } from "./../../../../enums/locale.enum";
import store from "./../../../../store";
import { mapGetters } from "vuex";

export default Vue.extend({
  data() {
    return {
      I18nLocaleEnum,
      showProfileMenu: false,
    };
  },
  props: ["src"],
  components: {
    ProfileIcon,
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    changeLanguage(lang: string) {
      this.$i18n.locale = lang;
      localStorage.setItem(StorageKeys.lang, lang);
    },
    async logout() {
      authService
        .LogOut()
        .then(() => {
          store.commit("aiAssistant/close");
          store.dispatch("setUser", null);
          window.localStorage.removeItem(StorageKeys.user);
          this.$router.push("/" + Routes.login);
        })
        .catch((error) => {
          console.error(error.message || error.response.data);
        });
    },
    toggleShowProfileMenu() {
      this.showProfileMenu = !this.showProfileMenu;
    },
  },
  mounted() {},
});
</script>
